import * as React from 'react'
import Svg from '../Svg'
export const SvgLock = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        viewBox="0 0 63.1 85"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <path d="M54.5 28.4h-2.6c0-4.4-.1-10.8-.3-11.9C50 6.4 42.3 0 31.6 0 21 0 13.4 6.3 11.6 16.3c-.2 1.3-.3 7.6-.4 12.1H8.6c-4.7 0-8.6 4.3-8.6 9.7v37.1C0 80.7 3.9 85 8.6 85h46c4.7 0 8.6-4.3 8.6-9.7V38.2c-.1-5.3-3.9-9.8-8.7-9.8zM39.1 70.6h-15L29 58.3c-2.9-1.1-4.9-3.9-4.9-7 0-4.1 3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5c0 3.3-2 6-4.9 7l4.9 12.3zM20.3 28.4c.1-4.1.1-9.5.3-10.7 1.3-7.6 7.5-8.7 11-8.7 3.6 0 9.7 1.2 11.1 8.9.1 1.1.2 6.4.2 10.5H20.3z" />
    </Svg>
)
SvgLock.isIcon = true
export default SvgLock
